import { Link, useLocation } from 'react-router-dom';
import logo from '/isologo.svg';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import './DAppHeader.scss';

export default function DAppHeader() {
  const location = useLocation();
  const path = location.pathname;

  return (
    <header className="dapp-header">
      <div className="container">
        <div className="dapp-header-content">
          <Link to="/">
            <img className="logo" src={logo} />
          </Link>

          <nav className="dapp-nav">
            <Link
              to="/app"
              className={`dapp-nav__link ${path === '/app' ? 'dapp-nav__link--active' : ''}`}
            >
              Active Videos
            </Link>
            <Link
              to="/pending"
              className={`dapp-nav__link ${path === '/pending' ? 'dapp-nav__link--active' : ''}`}
            >
              Pending
            </Link>
            <Link
              to="/my-bets"
              className={`dapp-nav__link ${path === '/my-bets' ? 'dapp-nav__link--active' : ''}`}
            >
              My Bets
            </Link>
          </nav>

          <div className="dapp-header-actions">
            <ConnectButton />
          </div>
        </div>
      </div>
    </header>
  );
}
